import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription, Subject } from 'rxjs';
import { Account } from '../../../shared/account/account';
import { Pageable } from '../models/pageable';
import { Referral } from '../models/referral';
import { ReferralRepositoryService } from '../repositories/referral-repository.service';

@Injectable({
    providedIn: 'root'
})
export class ReferralService implements OnDestroy {

    sub = new Subscription();
    isIframe = false;
    loginDisplay = false;
    private readonly _destroying$ = new Subject<void>();
    loggedInUser = new Subject<Account | null | undefined>();
    isUserAuthenticated = new Subject<boolean>();

    constructor(private _referralRepository: ReferralRepositoryService) { }

    ngOnDestroy(): void {
        // clean up subscriptions
        if (this.sub) {
            this.sub.unsubscribe();
        }

        this._destroying$.next(undefined);
        this._destroying$.complete();
    }

    // referral
    saveReferral(referral: Referral): Observable<Referral> {
        referral.cleanUpBeforeSaving();
        return this._referralRepository.save(referral);
    }

    updateReferral(referral: Referral): Observable<Referral> {
        referral.cleanUpBeforeSaving();
        return this._referralRepository.update(referral);
    }

    findReferralById(id: string): Observable<Referral> {
        return this._referralRepository.findById(id);
    }

    findAllReferrals(pageable: Pageable, search: string): Observable<Referral[]> {
        return this._referralRepository.findAll(pageable, search);
    }
}